export default __webpack_public_path__ + "static/media/left-arrow.8718733f.svg";